import { Injectable } from "@angular/core";
import { MedOptionType } from "@mk/med-ui";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { env } from "@environments/environment";

interface SuppliesFilterModel {
  agreementNum: string[]
  status: string[]
  direction: string[]
  subDirection: string[]
  mnn: string[]
  warehouse: string[]
  supplier: string[]
  expectedDate: string[] | null
  actualDate: string[] | null
}

interface ReservesFilterModel {
  lovId: string[]
  mnnId: string[]
  direction: string[]
  mnn: string[]
  dosage: string[]
  measure: string[]
  reject: string[]
  availability: string[]
  documents: string[]
  subDirection: string[]
  controlDate: string[] | null
}

@Injectable({ providedIn: "root" })
export class FilterService {

  constructor(private http: HttpClient) {
  }

  showSuppliesFilter = false;
  showReservesFilter = false;
  goodSpecificationsShowed = false;

  supplies = {
    agreementNum: [],
    status: [],
    direction: [],
    subDirection: [],
    mnn: [],
    warehouse: [],
    supplier: [],
    expectedDate: [],
    actualDate: [],
  } as SuppliesFilterModel;

  reserves = {
    lovId: [],
    mnnId: [],
    direction: [],
    mnn: [],
    dosage: [],
    measure: [],
    reject: [],
    availability: [],
    documents: [],
    subDirection: [],
    controlDate: [],
  } as ReservesFilterModel;

  suppliesSubject: BehaviorSubject<SuppliesFilterModel> = new BehaviorSubject(this.supplies);
  reservesSubject: BehaviorSubject<ReservesFilterModel> = new BehaviorSubject(this.reserves);

  suppliesOptions = {
    agreementNums: [],
    statuses: [
      {
        label: "Узгодження",
        value: "Узгодження",
      },
      {
        label: "Поставлено",
        value: "Поставлено",
      },
    ],
    directions: [
      {
        label: "Ювенільний ревматоїдний артрит",
        value: "Ювенільний ревматоїдний артрит",
      },
      {
        label: "Ідіопатична сімейна дистонія",
        value: "Ідіопатична сімейна дистонія",
      },
      {
        label: "Розсіяний склероз",
        value: "Розсіяний склероз",
      },
      {
        label: "Серцево-судинні захворювання",
        value: "Серцево-судинні захворювання",
      },
      {
        label: "Легенева артеріальна гіпертензія",
        value: "Легенева артеріальна гіпертензія",
      },
      {
        label: "Дитячий церебральний параліч",
        value: "Дитячий церебральний параліч",
      },
      {
        label: "Слухові апарати",
        value: "Слухові апарати",
      },
      {
        label: "ПЛР-тести COVID-19",
        value: "ПЛР-тести COVID-19",
      },
      {
        label: "Cлухопротезування",
        value: "Cлухопротезування",
      },
      {
        label: "Дитячі розлади психіки",
        value: "Дитячі розлади психіки",
      },
      {
        label: "Доросла онкологія",
        value: "Доросла онкологія",
      },
      {
        label: "Ендопротези",
        value: "Ендопротези",
      },
      {
        label: "Донорство крові",
        value: "Донорство крові",
      },
      {
        label: "Обладнання для центрів ядерної медицини",
        value: "Обладнання для центрів ядерної медицини",
      },
      {
        label: "Медична допомога в умовах воєнного стану",
        value: "Медична допомога в умовах воєнного стану",
      },
      {
        label: "Медвироби для ортопедії та нейрохірургії",
        value: "Медвироби для ортопедії та нейрохірургії",
      },
    ],
    subDirections: [
      {
        label: "Препарати для лікування онкологічних та онкогематологічних хворих",
        value: "Препарати для лікування онкологічних та онкогематологічних хворих",
      },
    ],
    mnns: [
      {
        label: "Гемцитабін",
        value: "Гемцитабін",
      },
    ],
    warehouses: [
      {
        label: "Укрмедпостач",
        value: "Укрмедпостач",
      },
      {
        label: "БЦФ",
        value: "БЦФ",
      },
    ],
    suppliers: [],
  };

  reservesOptions = {

  };

  all: MedOptionType<string>[] = [
    {
      label: "Всі",
      value: "Всі",
    },
  ];

  public options(): MedOptionType<string>[] {
    return this.all;
  }

  suppliesPageHasFilters(): boolean {
    return  !!(this.supplies.mnn.length ||
            this.supplies.supplier.length ||
            this.supplies.warehouse.length ||
            this.supplies.status.length ||
            this.supplies.agreementNum.length ||
            this.supplies.direction.length ||
            this.supplies.subDirection.length ||
            (this.supplies.expectedDate && this.supplies.expectedDate.length) ||
            (this.supplies.actualDate && this.supplies.actualDate.length));
  }

  reservesPageHasFilters(): boolean {
    return !!(
      this.reserves.lovId.length ||
        this.reserves.mnnId.length ||
        this.reserves.direction.length ||
        this.reserves.mnn.length ||
        this.reserves.dosage.length ||
        this.reserves.measure.length ||
        this.reserves.reject.length ||
        this.reserves.availability.length ||
        this.reserves.documents.length ||
        this.reserves.subDirection.length ||
        (this.reserves.controlDate && this.reserves.controlDate.length)
    );
  }

  filtersCount(path: string): number {
    let count = 0;
    if (path === "/supplies") {
      Object.entries(this.supplies)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([key, value]) => {
          if (value && value.length) {
            count++;
          }
        });
    } else if (path === "/reserves") {
      Object.entries(this.reserves)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([key, value]) => {
          if (value && value.length) {
            count++;
          }
        });
    }
    return count;
  }

  suppliesStateChanged() {
    this.supplies.supplier = this.supplies.supplier.filter(supplier => supplier);
    this.supplies.agreementNum = this.supplies.agreementNum.filter(supplier => supplier);
    this.supplies.status = this.supplies.status.filter(supplier => supplier);
    this.supplies.direction = this.supplies.direction.filter(supplier => supplier);
    this.supplies.subDirection = this.supplies.subDirection.filter(supplier => supplier);
    this.supplies.mnn = this.supplies.mnn.filter(supplier => supplier);
    this.supplies.warehouse = this.supplies.warehouse.filter(supplier => supplier);
    this.suppliesSubject.next(this.supplies);
  }

  reservesStateChanged() {
    this.reserves.subDirection = this.reserves.subDirection.filter(supplier => supplier);
    this.reserves.availability = this.reserves.availability.filter(supplier => supplier);
    this.reserves.measure = this.reserves.measure.filter(supplier => supplier);
    this.reserves.dosage = this.reserves.dosage.filter(supplier => supplier);
    this.reserves.direction = this.reserves.direction.filter(supplier => supplier);
    this.reserves.mnn = this.reserves.mnn.filter(supplier => supplier);
    this.reservesSubject.next(this.reserves);
  }

  resetFilter(path: string) {
    if ("/supplies" === path) {
      this.supplies = {
        agreementNum: [],
        status: [],
        direction: [],
        subDirection: [],
        mnn: [],
        warehouse: [],
        supplier: [],
        expectedDate: [],
        actualDate: [],
      } as SuppliesFilterModel;
      this.suppliesStateChanged();
    } else if ("/reserves" === path) {
      this.reserves = {
        lovId: [],
        mnnId: [],
        direction: [],
        mnn: [],
        dosage: [],
        measure: [],
        reject: [],
        availability: [],
        documents: [],
        subDirection: [],
        controlDate: [],
      } as ReservesFilterModel;
      this.reservesStateChanged();
    }
  }

  onLovIdChange(value: string): void {
    if (isNaN(Number(value)) || value.trim() === "") {
      this.reserves.lovId = [];
    }
  }

  onMnnIdChange(value: string): void {
    if (isNaN(Number(value)) || value.trim() === "") {
      this.reserves.mnnId = [];
    }
  }

  onAvailabilityIdChange(value: string): void {
    if (isNaN(Number(value)) || value.trim() === "") {
      this.reserves.availability = [];
    }
  }

  loadDistinctsForDropdowns(): void {
    this.http.get<any>(env.logisticsServiceBackend + "/logistics/v1/goods/list?size=100").subscribe(data => {
      if (data && data.content) {
        this.suppliesOptions.mnns = [];
        data.content.forEach((val: string) => {
          this.suppliesOptions.mnns.push({ label: val, value: val });
        });
      }
    });

    const currentYear = new Date().getFullYear();
    const years: number[] = [];
    years.push(currentYear);
    years.push(currentYear - 1);
    years.push(currentYear - 2);
    years.push(currentYear - 3);
    this.suppliesOptions.directions = [];
    years.forEach((year: number) => {
      this.http.get<any>(env.logisticsServiceBackend + "/logistics/v1/dictionary/direction/" + year).subscribe(data => {
        data.forEach((direct: any) => {
          const direction = { label: direct["shortName"], value: direct["id"] };
          if (!this.suppliesOptions.directions.includes(direction)) {
            this.suppliesOptions.directions.push(direction);
          }
        });
        this.suppliesOptions.directions.sort((a, b) => a.label.localeCompare(b.label));
      });
    });
  }
}
